import { getCoreRowModel, getSortedRowModel } from "@tanstack/react-table"
import type { SortingState } from "@tanstack/react-table"
import type { FC } from "react"
import { useState } from "react"

import type { CompanyProductAlternative } from "../../hooks/useGetAlternativesList"

import { useAlternativeColumns } from "./useAlternativeColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"

interface ProductAlternativesTableProps {
  alternatives: CompanyProductAlternative[]
  isFetching: boolean
  onDelete: (id: string) => void
  canEdit: boolean
}

export const ProductAlternativesTable: FC<ProductAlternativesTableProps> = ({
  alternatives,
  isFetching,
  onDelete,
  canEdit,
}) => {
  const { columns } = useAlternativeColumns({ onDelete, canEdit })
  const [sorting, setSorting] = useState<SortingState>([])

  return (
    <AerosBaseTable
      features={{
        tanstackOptions: {
          data: alternatives,
          columns,
          state: { sorting, isLoading: isFetching },
          getCoreRowModel: getCoreRowModel(),
          getSortedRowModel: getSortedRowModel(),
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          onSortingChange: setSorting,
        },
      }}
      noDataMessage='No alternatives found'
    />
  )
}
